function DefaultData() { }

DefaultData.GetKLineOption=function()
{
    //K线配置信息
    var option= 
    {
        Type:'历史K线图',   //创建图形类型
        
        Windows: //窗口指标
        [
            {Index:"MA", Modify:false, Change:false, Overlay:false, Export:false, MaxMin:false, Close:false, TitleWindow:false },
            {Index:"VOL", Modify:false, Change:false, Overlay:false, Export:false, MaxMin:false, Close:false, TitleWindow:false },
        ], 

        IsAutoUpdate:true,              //是自动更新数据
        AutoUpdateFrequency:2000,       //数据更新频率
        IsShowRightMenu:false,          //右键菜单
        symbol:'',
        IsApiPeriod:true,             //复权,周期都使用后台数据

        //CorssCursorTouchEnd:true,
        //StepPixel:5,        //移动一个K线需要的手势移动的像素(默认4)
        //ZoomStepPixel:8,    //缩放一次,2个手指需要移动的间距像素(默认5)

        KLine:  //K线设置
        {
            DragMode:1,                 //拖拽模式 0 禁止拖拽 1 数据拖拽 2 区间选择
            Right:0,                    //复权 0 不复权 1 前复权 2 后复权
            Period:0,                   //周期 0 日线 1 周线 2 月线 3 年线 
            MaxReqeustDataCount:1000,    //数据个数
            MaxRequestMinuteDayCount:10, //分钟数据取5天
            PageSize:30,                 //一屏显示多少数据
            IsShowTooltip:true,          //是否显示 div K线提示信息 (手机端要填false)
            DrawType:0,                   //K线类型 0=实心K线柱子 1=收盘价线 2=美国线 3=空心K线柱子 4=收盘价面积图
            RightSpaceCount:1
        },

        KLineTitle: //标题设置
        {
            IsShowName:true,       //不显示股票名称
            IsShowSettingInfo:true //不显示周期/复权
        },

        Border: //边框
        {
            Left:1,         //左边间距
            Right:80,       //右边间距
            Bottom:25,      //底部间距
            Top:25          //顶部间距
        },
        
        Frame:  //子框架设置
        [
            {   
                SplitCount:3,IsShowLeftText:false, Height:8,
                Custom: [ { Type:0, Position:'right' } ]
            },

            { SplitCount:2,IsShowLeftText:false, Height:2 },
        ],

        ExtendChart:    //扩展图形
        [
            //{Name:'KLineTooltip' }  //手机端tooltip
        ],
    };

    return option;
}
DefaultData.GetMinuteOption=function()
{
    var option= 
    {
        Type:'分钟走势图',   //创建图形类型
            
        Windows: //窗口指标
        [
            
        ], 
            
        IsAutoUpdate:true,       //是自动更新数据
        AutoUpdateFrequency:2000,       //数据更新频率
        DayCount:1,                 //1 最新交易日数据 >1 多日走势图
        IsShowRightMenu:false,       //是否显示右键菜单
        CorssCursorTouchEnd:true,
		IsClickShowCorssCursor:true,
		//IsFullDraw:true,
        symbol:'',
        MinuteLine:
        {
            //IsDrawAreaPrice:false,      //是否画价格面积图
        },
 
        Border: //边框
        {
            Left:1,    //左边间距
            Right:1,   //右边间距
            Top:20,
            Bottom:20
        },
            
        Frame:  //子框架设置
        [
            {SplitCount:3},
            {SplitCount:2},
            {SplitCount:3},
        ],
 
        ExtendChart:    //扩展图形
        [
            //{Name:'MinuteTooltip' }  //手机端tooltip
        ],
    };
 
    return option;
}
export default DefaultData
